export default __webpack_public_path__ + "static/media/logo.c13c6c48.svg";